import React from 'react'
import { MoveSupportIdContainer } from '../../../containers/SupportSystem/MoverSupportId/MoveSupportIdContainer'
export const MoverSupportIdPage = () => {
    return (
        <MoveSupportIdContainer />
    )
}
